export class LibSubContractorsPaymentsDto {
    id?:number;
    subContractorId: number;
    costCenterId:number;
    projectId:number;
    subContractor:string;
    paymentDate : Date | any;
    paidDate : Date | any;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;
  }
  export const LibSubContractorsPaymentsDtoDefault : LibSubContractorsPaymentsDto = {
    id:1,
    subContractorId: 0,
    costCenterId:0,
    projectId:0,
    subContractor:"",
    paymentDate : "",
    paidDate : "",
    createdAt : new Date(),
    createdUser : 0,
    updatedAt : new Date(),
    updatedUser : 0,
    versionFlag : 1
  };